import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-end mb-4" }
const _hoisted_2 = { class: "text-h4 font-weight-bold text-primary" }
const _hoisted_3 = { class: "text-h4 font-weight-bold text-primary" }

import { computed, onMounted, ref } from 'vue'
import Chart from 'chart.js/auto'
import { useStore } from 'vuex'
interface DashboardItem {
  total: number
  [key: string]: any
}

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'DashboardView'
},
  __name: 'DashboardView',
  setup(__props) {


const chartCanvas = ref<HTMLCanvasElement | null>(null)
const deviceChart = ref<HTMLCanvasElement | null>(null)
const browserChart = ref<HTMLCanvasElement | null>(null)
const osChart = ref<HTMLCanvasElement | null>(null)
const hourChart = ref<HTMLCanvasElement | null>(null)
const refererChart = ref<HTMLCanvasElement | null>(null)

let chartVisitas: Chart | null = null
let chartDispositivos: Chart | null = null
let chartNavegadores: Chart | null = null
let chartOS: Chart | null = null
let chartHoras: Chart | null = null
let chartReferers: Chart | null = null

const totalHorasDia = ref(0)
const diaTop = ref('')
const diasVisitas = ref(0)
const aColors = ref([
    '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC', '#26A69A',
    '#EC407A', '#FF7043', '#26C6DA', '#8D6E63', '#78909C', 
    '#FFCA28', '#FF8A65', '#7E57C', '#B39DDB', '#90A4AE'
  ])
const ultima_visita = ref('')

const dashboard = ref<DashboardItem[]>([])
const responseDashboad = computed(() => store.state.Dashboard.responseDashboad)
const store = useStore()
// let chartInstance: Chart | null = null
async function cargarGaleria() {
  
  // loadSkeleton.value = true
  await store.dispatch('Dashboard/getDashboard') 
  dashboard.value = responseDashboad.value?.data ?? []
  vistasDiarias()
  vistasDispositivos()
  vistasNavegacion()
  vistaOs()
  vistasPorHora()
  vistaReferers()
  calcularTotalHorasUltimoDia()
  calcularDiaMasVisitado()
  cargarUltimaVista()
}

function vistasDiarias() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  if (chartCanvas.value) {
    if (chartVisitas) {
      chartVisitas.destroy()
    }
    chartVisitas = new Chart(chartCanvas.value, {
      type: 'scatter',
      data: {
        labels: Object.keys(dataByDay),
        datasets: [
          {
            type: 'bar',
            label: 'Visitas totales por día',
            data: Object.values(dataByDay).map(v => v.total ?? 0),
            borderColor: '#08440aff',
            backgroundColor: '#4CAF50'
          },
        ],
      },
    })
  }
}

function vistasDispositivos() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  const totalDevices: Record<string, number> = {};
  for (const day of Object.values(dataByDay)) {
      for (const [k, v] of Object.entries(day.devices ?? {})) {
          const value = typeof v === 'number' ? v : 0;
          totalDevices[k] = (totalDevices[k] ?? 0) + value;
      }
  }
  if (deviceChart.value) {
    if (chartDispositivos) {
      chartDispositivos.destroy()
    }
    chartDispositivos = new Chart(deviceChart.value, {
      type: 'pie',
      data: {
        labels: Object.keys(totalDevices),
        datasets: [
          {
            label: 'Dispositivos',
            data: Object.values(totalDevices),
            backgroundColor: aColors.value
          },
        ],
      },
    })
  }
}

function vistasNavegacion() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  const totalBrowsers: Record<string, number> = {};
        for (const day of Object.values(dataByDay)) {
            for (const [k, v] of Object.entries(day.browsers ?? {})) {
                const value = typeof v === 'number' ? v : 0;
                totalBrowsers[k] = (totalBrowsers[k] ?? 0) + value;
            }
        }
  if (browserChart.value) {
    if (chartNavegadores) {
      chartNavegadores.destroy()
    }
    chartNavegadores = new Chart(browserChart.value, {
      type: 'doughnut',
      data: {
        labels: Object.keys(totalBrowsers),
        datasets: [
          {
            label: 'Navegadores',
            data: Object.values(totalBrowsers),
            backgroundColor: aColors.value
          },
        ],
      },
    })
  }
}

function vistaOs() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  const totalOS: Record<string, number> = {};
  for (const day of Object.values(dataByDay)) {
    for (const [k, v] of Object.entries(day.os ?? {})) {
      const value = typeof v === 'number' ? v : 0;
      totalOS[k] = (totalOS[k] ?? 0) + value;
    }
  }
  if (osChart.value) {
    if (chartOS) {
      chartOS.destroy()
    }
    chartOS = new Chart(osChart.value, {
      type: 'pie',
      data: {
        labels: Object.keys(totalOS),
        datasets: [
          {
            label: 'Sistemas Operativos',
            data: Object.values(totalOS),
            backgroundColor: aColors.value
          },
        ],
      },
    })
  }
}

function vistaReferers() {
  const totalReferers: Record<string, number> = {}
  for (const day of Object.values(dashboardLimitado.value)) {
    for (const [ref, count] of Object.entries(day.referers ?? {})) {
      totalReferers[ref] = (totalReferers[ref] ?? 0) + (count as number)
    }
  }

  if (refererChart.value) {
    if (chartReferers) {
      chartReferers.destroy()
    }
    chartReferers = new Chart(refererChart.value, {
      type: 'doughnut',
      data: {
        labels: Object.keys(totalReferers),
        datasets: [{
          label: 'Referers',
          data: Object.values(totalReferers),
          backgroundColor: aColors.value
        }],
      },
    })
  }
}

function vistasPorHora() {
  const horas = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'))

  const datasets = Object.entries(dashboardLimitado.value).map(([fecha, data], index) => {
    const hourlyData = data.hourly ?? {}
    const valoresPorHora = horas.map(hora => hourlyData[hora] ?? 0)

    return {
      label: fecha,
      data: valoresPorHora,
      backgroundColor: getColor(index),
      stack: 'visitas'
    }
  })

  if (hourChart.value) {
    if (chartHoras) {
      chartHoras.destroy()
    }
    chartHoras = new Chart(hourChart.value, {
      type: 'bar',
      data: {
        labels: horas.map(h => `${h}:00`),
        datasets
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            callbacks: {
              label: (context: any) => {
                const valor = context.raw
                return `${context.dataset.label}: ${valor} visita${valor !== 1 ? 's' : ''}`
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true,
            beginAtZero: true,
            ticks: {
              stepSize: 1
            }
          }
        }
      }
    })
  }
}
function getColor(index: number): string {
  const colores = aColors.value;
  return colores[index % colores.length]
}

function cargarUltimaVista() {
  const fechas = Object.keys(dashboardLimitado.value)
  if (fechas.length === 0) return
  
  const ultimaFecha: any = fechas[fechas.length - 1]
  const dataUltimoDia = dashboardLimitado.value[ultimaFecha]
    ultima_visita.value = dataUltimoDia.last_updated

}

function calcularDiaMasVisitado() {
  const diasSemana: Record<string, number> = {}
  let diasMaximo: any = []

  for (const [fecha, data] of Object.entries(dashboardLimitado.value)) {
    const fechaOriginal = new Date(fecha);
    const fechaMasUnDia = new Date(fechaOriginal);
    fechaMasUnDia.setDate(fechaMasUnDia.getDate() + 1);
    const dia = fechaMasUnDia.toLocaleDateString('co-CO', { weekday: 'long' }) 
    diasSemana[dia] = (diasSemana[dia] ?? 0) + (data.total ?? 0)
    diasMaximo = {...diasSemana}
  } 
  diaTop.value = Object.entries(diasSemana).sort((a, b) => b[1] - a[1])[0]?.[0] ?? ''
  diasVisitas.value =  Math.max(...Object.values(diasMaximo).map(v => Number(v)))
}

function calcularTotalHorasUltimoDia() {
  const fechas = Object.keys(dashboardLimitado.value)
  if (fechas.length === 0) return
  
  const ultimaFecha: any = fechas[fechas.length - 1]
  const dataUltimoDia = dashboardLimitado.value[ultimaFecha]
  const horas = dataUltimoDia?.hourly ?? {}
  const totalHoras = Object.values(horas).reduce((sum: number, val: any) => sum + val, 0);
  totalHorasDia.value = totalHoras
}

const dashboardLimitado = computed(() => {
  const entradas = Object.entries(dashboard.value)
  const ultimos15 = entradas.slice(-7) // obtiene los últimos 15 registros
  return Object.fromEntries(ultimos15)
})

onMounted(() => {
  cargarGaleria();
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: cargarGaleria,
          "prepend-icon": "mdi-reload"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Recargar Widgets ")
          ])),
          _: 1,
          __: [0]
        })
      ]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-h5 mb-2" }, "VISITAS POR DÍA", -1)),
                  _createElementVNode("canvas", {
                    ref_key: "chartCanvas",
                    ref: chartCanvas
                  }, null, 512)
                ]),
                _: 1,
                __: [1]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-h5 mb-2" }, "VISITAS POR HORA (AGRUPADAS POR FECHA)", -1)),
                  _createElementVNode("canvas", {
                    ref_key: "hourChart",
                    ref: hourChart
                  }, null, 512)
                ]),
                _: 1,
                __: [2]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-h5 mb-2" }, "DISPOSITIVOS", -1)),
                  _createElementVNode("canvas", {
                    ref_key: "deviceChart",
                    ref: deviceChart
                  }, null, 512)
                ]),
                _: 1,
                __: [3]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-h5 mb-2" }, "NAVEGADORES", -1)),
                  _createElementVNode("canvas", {
                    ref_key: "browserChart",
                    ref: browserChart
                  }, null, 512)
                ]),
                _: 1,
                __: [4]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-h5 mb-2" }, "SISTEMA OPERATIVO", -1)),
                  _createElementVNode("canvas", {
                    ref_key: "osChart",
                    ref: osChart
                  }, null, 512)
                ]),
                _: 1,
                __: [5]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-h5 mb-2" }, "REFERERS", -1)),
                  _createElementVNode("canvas", {
                    ref_key: "refererChart",
                    ref: refererChart
                  }, null, 512)
                ]),
                _: 1,
                __: [6]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4 d-flex flex-column align-center justify-center text-center" }, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-subtitle-1" }, "Total Horas (último día)", -1)),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(totalHorasDia.value) + "h", 1),
                  _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-subtitle-1" }, "Última visita", -1)),
                  _createVNode(_component_v_chip, {
                    color: "green",
                    "text-color": "white",
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(ultima_visita.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [7,8]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pa-4 d-flex flex-column align-center justify-center text-center" }, {
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-subtitle-1" }, "Día con más visitas", -1)),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(diaTop.value) + " (" + _toDisplayString(diasVisitas.value) + ")", 1)
                ]),
                _: 1,
                __: [9]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})